import { storage } from '@repo/ui'
import { toast } from 'react-toastify'

export const handleSignup = () => {
  localStorage.setItem('redirectURL', '/stays')
  window.location.href = process.env.NEXT_PUBLIC_WEBSITE_URL
}

export const onHandleLogout = () => {
  setTimeout(() => {
    window.location.href = `${process.env.NEXT_PUBLIC_WEBSITE_URL}/stays`
  }, 300)

  // Preserve currency preferences using the proper storage service
  const hadStoredPrefs = storage.hasStoredPrefs()
  const currentPrefs = storage.getUserPrefs()
  const preservedData = {
    country: currentPrefs.country,
    currency: currentPrefs.currency,
    currency_symbol: currentPrefs.currency_symbol,
    conversionRate: localStorage.getItem('conversionRate'), // Keep this as is since it's not part of our currency system
  }

  localStorage.clear()

  // Restore currency preferences only if they existed before logout
  if (hadStoredPrefs) {
    storage.setUserPrefs({
      country: preservedData.country,
      currency: preservedData.currency,
      currency_symbol: preservedData.currency_symbol,
    })
  }

  // Restore conversion rate separately
  if (preservedData.conversionRate) {
    localStorage.setItem('conversionRate', preservedData.conversionRate)
  }

  toast.success('Successfully Logged out')
}

export const whatsappUrl = 'http://wa.me/201017908546'
// export const whatsappUrl = 'https://api.whatsapp.com/send/?phone=%2B201030110692&text&type=phone_number&app_absent=0'
export const formatNumber = (number) => {
  return new Intl.NumberFormat('en-US').format(number)
}
